module.exports = __webpack_public_path__ + "img/70.71927b3f.webp";